import { render, staticRenderFns } from "./sample.vue?vue&type=template&id=4da6e123&scoped=true"
import script from "./sample.vue?vue&type=script&lang=js"
export * from "./sample.vue?vue&type=script&lang=js"
import style0 from "./sample.vue?vue&type=style&index=0&id=4da6e123&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da6e123",
  null
  
)

export default component.exports